import { render, staticRenderFns } from "./LunchSummary.vue?vue&type=template&id=6ad9d056&scoped=true"
import script from "./LunchSummary.vue?vue&type=script&lang=js"
export * from "./LunchSummary.vue?vue&type=script&lang=js"
import style0 from "./LunchSummary.vue?vue&type=style&index=0&id=6ad9d056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad9d056",
  null
  
)

export default component.exports